import { ClassConstructor } from "class-transformer";

import { PostActionTypeEnum } from "../../types";
import DeletePostActionModel from "./DeletePostAction/DeletePostActionModel";
import EditPostActionModel from "./EditPostAction/EditPostActionModel";
import { PostActionModel } from "./PostActionModel";
import SendCommentActionModel from "./SendCommentAction/SendCommentActionModel";
import UnpinChatMessageActionModel from "./UnpinChatMessageAction/UnpinChatMessageActionModel";

export default class PostActionTypes {
  static actionTypes: Array<{ name: PostActionTypeEnum | string, value: ClassConstructor<PostActionModel> }> = [
    { name: PostActionTypeEnum.DeletePostAction, value: DeletePostActionModel },
    { name: PostActionTypeEnum.EditPostAction, value: EditPostActionModel },
    { name: PostActionTypeEnum.SendCommentAction, value: SendCommentActionModel },
    { name: PostActionTypeEnum.UnpinChatMessageAction, value: UnpinChatMessageActionModel },
  ]

  static addCustomPostActionTypes(item: { name: PostActionTypeEnum | string, value: ClassConstructor<PostActionModel> }) {
    PostActionTypes.actionTypes.push(item)
  }
}
